const SESSION_KEY = 'dmsc_app_data';

export const getStorageItem = () => {
    try {
        const item = window.sessionStorage.getItem(SESSION_KEY);
        return item ? JSON.parse(item) : null;

    } catch (error) {
        console.log(error);
        return null;
    }
}

export const setStorageItem = (value) => {
    try {
        const valueToStore = value;
        window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(valueToStore));

    } catch (error) {
        console.log(error);
    }
}

export const clearStorage = () => window.sessionStorage.removeItem(SESSION_KEY);